export enum JobExperienceLevelEnum {
  EntryLevel = 'EntryLevel',
  MidLevel = 'MidLevel',
  Senior = 'Senior'
}

export const JOB_EXPERIENCE_LEVEL_DISPLAY: Record<
  JobExperienceLevelEnum,
  string
> = {
  [JobExperienceLevelEnum.EntryLevel]: 'Entry Level',
  [JobExperienceLevelEnum.MidLevel]: 'Mid Level',
  [JobExperienceLevelEnum.Senior]: 'Senior'
};
